import { Inject, Injectable, Optional } from '@angular/core';

import { appConfigValues } from './app-configuration.token';

@Injectable()
export class AppConfigurationService {
  configValuesOverrides: Map<string, string> = new Map<string, string>;
  mergedMaps: Map<string, string>

  constructor(
    @Optional() @Inject(appConfigValues) private readonly configValues: Map<string, string>,
  ) {
    this.mergeItems();
  }

  /**
   * Gets config value for requested key (attribute)
   *
   * @param {string} key
   */
  get(key: string): string {
    return this.mergedMaps.get(key);
  }

  getAllConfiguration(): Map<string, string> {
    return this.mergedMaps;
  }

  override(configKey: string, configValue: string) {
    this.configValuesOverrides[configKey] = configValue;
    this.mergeItems();
  }

  mergeItems() {
    this.mergedMaps = new Map([...this.configValues.entries(), ...this.configValuesOverrides.entries()])
  }
}
